export default __webpack_public_path__ + "static/media/DtVkJx26TKEr37c9aBBxJlkc5yjTjQJElti5.55999f67.woff2";